import React from "react";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
// import heroImage from "./media/property-hero.jpg"; // replace with your image

const WhatsAppHero = () => {
  const WHATSAPP_LINK = "https://chat.whatsapp.com/HjoR601OWZdJ2PFeUrwWdj?mode=ems_share_t";
const WhatsAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    className="h-5 w-5"
    fill="currentColor"
  >
    <path d="M380.9 97.1C339-5.5 224-28 149.3 47.7c-75 75-52.6 189 45 233.7l-25 91.7c-5.7 20.9 17.8 37 35.8 26.5l95.4-57.1c43.9 23.9 97.2 14.1 133.2-22.9 45.4-45.4 46.8-118.3 6.2-168.5zm-114.8 248.8l-53.3 31.9-19.9-28.6c-4.8-6.8-11.3-12-18.6-15.8-17.6-8.5-29.6-26.8-31.2-46.7l-2.2-23.6 109.4 65.1zM377.3 134c-32.6-32.6-79-45.1-123.4-34.1-2.1.5-4.2 1-6.3 1.5-15.3 3.7-29.9 11.1-42.6 22.8-20.6 18.7-33.5 45.5-35.3 74.4-.2 3.2-.5 6.5-.5 9.7 0 28.2 10.5 54.6 29.5 74.6 19 20 45.1 30.5 72.9 30.5 3.2 0 6.5-.2 9.7-.5 29-1.8 55.7-14.7 74.4-35.3 11.7-12.7 19-27.3 22.8-42.6.5-2.1 1-4.2 1.5-6.3 10.9-44.3-1.5-90.8-34.1-123.4z"/>
  </svg>
);

  return (
    <section className="relative bg-gradient-to-br from-neutral-50 to-white overflow-hidden">
      <div className="container mx-auto px-6 lg:px-20 flex flex-col-reverse lg:flex-row items-center lg:justify-between py-24 lg:py-32 gap-12">
        
        {/* Left Content */}
        <div className="flex-1 space-y-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-primary leading-tight">
            Discover Your Dream Property in Solapur
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-xl">
            We post verified properties daily so you can make smart investment decisions. 
            Join our WhatsApp group to stay updated instantly with the latest listings.
          </p>

          <div className="flex flex-wrap gap-4 mt-6">
            <Button
              size="lg"
              className="bg-gradient-to-r from-green-500 to-teal-500 text-white border-0 shadow-lg hover:from-teal-500 hover:to-green-500 transition-all duration-300 flex items-center gap-2"
              onClick={() => window.open(WHATSAPP_LINK, "_blank")}
            >
              <WhatsAppIcon className="w-5 h-5" />
              Join WhatsApp Group
              <ArrowRight className="w-4 h-4" />
            </Button>

            <Button
              size="lg"
              className="bg-white text-primary border border-primary shadow-md hover:bg-primary hover:text-white transition-all duration-300 flex items-center gap-2"
              onClick={() => window.scrollTo({ top: document.getElementById("contact").offsetTop, behavior: "smooth" })}
            >
              Contact Us
              <ArrowRight className="w-4 h-4" />
            </Button>
          </div>
        </div>

        {/* Right Image */}
        {/* <div className="flex-1 flex justify-center lg:justify-end">
          <img 
            src={heroImage} 
            alt="Properties in Solapur" 
            className="rounded-3xl shadow-xl w-full max-w-md lg:max-w-lg object-cover"
          />
        </div> */}

      </div>
    </section>
  );
};

export default WhatsAppHero;
